import React from 'react';

import PhoneVerificationForm from 'components/PhoneVerificationForm';
import { BorrowerType } from 'enums/BorrowerType';

const BorrowerPhoneVerification = () => {
  return <PhoneVerificationForm borrowerType={BorrowerType.Borrower} />;
};

export default BorrowerPhoneVerification;
